module.exports = __webpack_public_path__ + "img/huaBei.aee90f39.png";